var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exportar-dados row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"container-cards"},_vm._l((_vm.cards),function(card,index){return _c('CardExport',{key:index,attrs:{"title":card.title,"subtitle":card.subtitle,"image":card.image,"itemsXls":card.itemsXls,"endpoint":_vm.generateEndpoint(card.endpoint)}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }